import {
  Avatar,
  Badge,
  Box,
  Button,
  Container,
  Grid,
  Paper,
  styled,
  Typography,
  IconButton,
  InputBase,
  Divider,
  Modal,
  TextField,
} from "@mui/material";
import React, { useEffect, useState, useRef, useLayoutEffect } from "react";
import Texto from "./Texto";
import {
  TIPOS_DOCUMENTOS,
  TIPOS_MENSAJES,
  CELL_PHONE_COBRANZA,
} from "../../Constants";
import { axiosClient } from "../AxiosClient";
import Image from "./Image";
import Video from "./Video";
import Document from "./Document";
import { useParams, useNavigate } from "react-router-dom";
import Interactive from "./Interactive";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import SendIcon from "@mui/icons-material/Send";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import SearchIcon from "@mui/icons-material/Search";
import ContactList from "./ContactList";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import Audio from "./Audio";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import CheckIcon from "@mui/icons-material/Check";
import { Client } from "@stomp/stompjs";
import SockJS from "sockjs-client";

const MainContainer = styled(Box)({
  display: "flex",
  height: "calc(100vh - 100px)",
  backgroundColor: "#f0f2f5",
  marginTop: "100px",
  marginLeft: "calc(240px + 25%)",
  width: "calc(75% - 240px)",
  position: "fixed",
  right: 0,
});

const ChatSection = styled(Box)({
  flex: 1,
  display: "flex",
  flexDirection: "column",
  width: "100%",
  height: "100%",
  overflow: "hidden",
});

const ChatContainer = styled(Box)({
  flex: 1,
  display: "flex",
  flexDirection: "column",
  height: "100%",
  overflow: "hidden",
});

const ChatHeader = styled(Box)({
  backgroundColor: "#f0f2f5",
  padding: "10px 16px",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  borderBottom: "1px solid #e0e0e0",
  height: "60px",
  minHeight: "60px",
});

const ClientInfo = styled(Box)({
  display: "flex",
  flexDirection: "column",
});

const ClientName = styled(Typography)({
  fontWeight: 500,
  fontSize: "16px",
  color: "#111b21",
});

const ClientNumber = styled(Typography)({
  fontSize: "13px",
  color: "#667781",
});

const ChatMessages = styled(Box)(({ theme }) => ({
  flex: 1,
  backgroundColor: "#efeae2",
  backgroundImage:
    'url("https://user-images.githubusercontent.com/15075759/28719144-86dc0f70-73b1-11e7-911d-60d70fcded21.png")',
  backgroundSize: "contain",
  overflowY: "auto",
  padding: "20px",
  height: "calc(100% - 120px)",
}));

const ChatInput = styled(Box)({
  backgroundColor: "#f0f2f5",
  padding: "10px 16px",
  display: "flex",
  alignItems: "center",
  gap: "8px",
  minHeight: "60px",
  borderTop: "1px solid #e0e0e0",
});

const MessageInput = styled(InputBase)(({ theme }) => ({
  flex: 1,
  backgroundColor: "#fff",
  borderRadius: "8px",
  padding: "9px 12px",
  fontSize: "15px",
}));

const StyledBadge = styled(Badge)(({ theme }) => ({
  "& .MuiBadge-badge": {
    backgroundColor: "#44b700",
    color: "#44b700",
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
    "&::after": {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      borderRadius: "50%",
      animation: "ripple 1.2s infinite ease-in-out",
      border: "1px solid currentColor",
      content: '""',
    },
  },
  "@keyframes ripple": {
    "0%": {
      transform: "scale(.8)",
      opacity: 1,
    },
    "100%": {
      transform: "scale(2.4)",
      opacity: 0,
    },
  },
}));

const WelcomeScreen = styled(Box)({
  flex: 1,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "#f0f2f5",
  "& img": {
    width: "250px",
    marginBottom: "20px",
  },
});

const SearchContainer = styled(Box)({
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  backgroundColor: "#fff",
  zIndex: 1,
  display: "flex",
  alignItems: "center",
  padding: "8px 16px",
  gap: "8px",
  borderBottom: "1px solid #e0e0e0",
});

const SearchInput = styled(InputBase)({
  flex: 1,
  fontSize: "15px",
});

const ButtonAdd = styled(Button)({
    flexGrow: 0,
    borderRadius: '20px',
    gap: '10px',
    backgroundColor: '#161e55',
    color: '#ffff',
    margin: '0px 1rem',
    '&:hover': {
        backgroundColor: '#A8C8AF',
    },
});

/*************************** */
const searchByCellphone = (setState, cellphone) => {
  axiosClient
    .get(`v1/conversations/admin/${CELL_PHONE_COBRANZA}/cellphone/${cellphone}`)
    .then((response) => {
      const serverData = response.data;
      setState(serverData);
    })
    .catch((error) => {});
};

/*************************** */
export const fetchMediaUrl = (key, setUrl, extension = ".jpg") => {
  axiosClient
    .get(`/v1/s3/url/${key}`)
    .then((response) => setUrl(response.data))
    .catch((error) => {});
};

export default function ChatCobranza() {
  const [datos, setData] = useState();
  const [message, setMessage] = useState("");
  const [selectedContact, setSelectedContact] = useState(null);
  const [searchMode, setSearchMode] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const messagesEndRef = useRef(null);
  const [openImageModal, setOpenImageModal] = useState(false);
  const [modalMediaSrc, setModalMediaSrc] = useState("");
  const [modalMediaType, setModalMediaType] = useState("image");
  const [isEditingName, setIsEditingName] = useState(false);
  const [editedName, setEditedName] = useState("");
  const [showScrollToBottom, setShowScrollToBottom] = useState(false);
  const [updateTrigger, setUpdateTrigger] = useState(0);
  const editNameBoxRef = useRef(null);
  const messageRefs = useRef({});
  const shouldScrollOnLoadRef = useRef(false);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({
      behavior: "auto",
      block: "end",
    });
  };

  const isUserAtBottom = () => {
    const el = messagesEndRef.current?.parentNode;
    if (!el) return true;
    return el.scrollHeight - el.scrollTop - el.clientHeight < 50;
  };

  useLayoutEffect(() => {
    if (shouldScrollOnLoadRef.current && datos?.messages?.length) {
      requestAnimationFrame(() => {
        scrollToBottom();
        shouldScrollOnLoadRef.current = false;
      });
    }
  }, [datos?.messages]);

  useEffect(() => {
    if (selectedContact) {
      if (selectedContact.senderCellphone === CELL_PHONE_COBRANZA) {
        searchByCellphone(setData, selectedContact.recipientCellphone);
      } else {
        searchByCellphone(setData, selectedContact.senderCellphone);
      }
    }
  }, [selectedContact]);

  useEffect(() => {
    const el = messagesEndRef.current?.parentNode;
    if (!el) return;
    const handleScroll = () => {
      if (isUserAtBottom()) setShowScrollToBottom(false);
    };
    el.addEventListener("scroll", handleScroll);
    return () => el.removeEventListener("scroll", handleScroll);
  }, [datos?.messages]);

  const handleContactSelect = (contact) => {
    // Clonar para garantizar un nuevo objeto y disparar useEffect aunque sea el mismo contacto
    setSelectedContact({ ...contact });
    setData(undefined);
    shouldScrollOnLoadRef.current = true;
    setSearchMode(false);
    setSearchTerm("");
  };

  const handleSearchSelect = () => {
    if (selectedContact.senderCellphone === CELL_PHONE_COBRANZA) {
      searchByCellphone(setData, selectedContact.recipientCellphone);
    } else {
      searchByCellphone(setData, selectedContact.senderCellphone);
    }
    setUpdateTrigger((prev) => prev + 1);
  }

  /*************************************INICIO */
  const now = new Date();
  const timeSent = now.toTimeString().split(" ")[0];

  const handleSendMessage = () => {
    console.log("");
    console.log(message)
    console.log(selectedContact)
    if (message.trim() && selectedContact?.recipientCellphone) {
      const newMessage = {
        type: "text",
        message: message.trim(),
        senderCellphone: CELL_PHONE_COBRANZA,
        recipientCellphone:
          selectedContact.recipientCellphone === CELL_PHONE_COBRANZA
            ? selectedContact.senderCellphone
            : selectedContact.recipientCellphone,
        timeSent: timeSent,
      };

      axiosClient.post('/v1/whatsapp-clients/solicitudes/send', {
        cellphone: selectedContact.recipientCellphone === CELL_PHONE_COBRANZA
          ? selectedContact.senderCellphone
          : selectedContact.recipientCellphone,
        message: newMessage.message,
      })
      .then((response) => {
        setMessage("");
        if (selectedContact.senderCellphone === CELL_PHONE_COBRANZA) {
        searchByCellphone(setData, selectedContact.recipientCellphone);
        } else {
          searchByCellphone(setData, selectedContact.senderCellphone);
        }
      })
      .catch((error) => {
        console.error("Error al enviar el mensaje:", error);
      });

    }
  };
  /************************************* */

  useEffect(() => {
    if (!searchMode || !searchTerm) return;
    const lower = searchTerm.toLowerCase();
    const match = datos?.messages?.find(
      (m) =>
        m.type === TIPOS_DOCUMENTOS.text &&
        m.message.toLowerCase().includes(lower)
    );
    if (match) {
      const el = messageRefs.current[match.uuid];
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }
  }, [searchTerm, searchMode, datos]);

  const handleSearchClick = () => {
    setSearchMode(!searchMode);
    if (searchMode) {
      setSearchTerm("");
    }
  };

  const handleNameClick = () => {
    setIsEditingName(true);
    setEditedName(datos?.name || "");
  };

  const handleNameChange = (event) => {
    setEditedName(event.target.value);
  };

  const handleNameSave = async () => {
    setIsEditingName(false);
    const newName = editedName.trim();
    if (!newName) return;
    const phone =
      selectedContact.senderCellphone == CELL_PHONE_COBRANZA
        ? selectedContact.recipientCellphone
        : selectedContact.senderCellphone;
    if (!phone) return;
    try {
      await axiosClient.patch(`/v1/directory/phone/${phone}`, {
        name: newName,
        phone,
      });
      setSelectedContact({...selectedContact, name: newName });
    } catch (error) {
      console.error("Error actualizando el nombre en el backend:", error);
    }
    setData((prevDatos) => ({
      ...prevDatos,
      name: newName,
      lastName: "",
    }));
    setSelectedContact((prevSelContact) => ({
      ...prevSelContact,
      name: newName,
      lastName: "",
    }));
  };

  return (
    <MainContainer>
      <ContactList
        onContactSelect={handleContactSelect}
        selectedContact={selectedContact}
        updateTrigger={updateTrigger}
      />

      <ChatSection>
        {selectedContact ? (
          <ChatContainer>
            <ChatHeader>
              {searchMode ? (
                <SearchContainer>
                  <IconButton onClick={handleSearchClick}>
                    <ArrowBackIcon />
                  </IconButton>
                  <SearchInput
                    autoFocus
                    placeholder="Buscar mensajes..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                </SearchContainer>
              ) : (
                <>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                    <StyledBadge
                      overlap="circular"
                      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                    >
                      <Avatar
                        sx={{ bgcolor: "#00a884", width: 40, height: 40 }}
                      >
                        {isEditingName
                          ? editedName?.[0]?.toUpperCase() || "?"
                          : (
                              datos?.name?.[0] ||
                              datos?.senderCellphone?.[0] ||
                              selectedContact?.senderCellphone?.[0] ||
                              "?"
                            ).toUpperCase()}
                      </Avatar>
                    </StyledBadge>
                    <ClientInfo>
                      {isEditingName ? (
                        <Box
                          ref={editNameBoxRef}
                          sx={{ display: "flex", alignItems: "center", gap: 1 }}
                        >
                          <InputBase
                            value={editedName}
                            onChange={handleNameChange}
                            onBlur={() => setIsEditingName(false)}
                            onKeyPress={(e) => {
                              if (e.key === "Enter") {
                                e.preventDefault();
                                handleNameSave();
                              }
                            }}
                            autoFocus
                            sx={{
                              fontWeight: 500,
                              fontSize: "16px",
                              color: "#111b21",
                              borderBottom: "1px solid #00a884",
                              padding: "0",
                              background: "#fff",
                            }}
                          />
                          <IconButton
                            size="small"
                            color="success"
                            sx={{ minWidth: 0, px: 0.5, py: 0.5 }}
                            onMouseDown={handleNameSave}
                          >
                            <CheckIcon fontSize="small" />
                          </IconButton>
                        </Box>
                      ) : (
                        <ClientName
                          onClick={handleNameClick}
                          sx={{
                            cursor: "pointer",
                          }}
                        >
                          {selectedContact?.name !== "" &&
                          selectedContact?.name != null
                            ? selectedContact.name
                            : selectedContact?.senderCellphone ===
                              CELL_PHONE_COBRANZA
                            ? selectedContact?.recipientCellphone ||
                              "Desconocido"
                            : selectedContact?.senderCellphone || "Desconocido"}
                        </ClientName>
                      )}
                      {selectedContact?.name !== "" &&
                        selectedContact?.name != null && (
                          <ClientNumber>
                            {selectedContact.senderCellphone ===
                            CELL_PHONE_COBRANZA
                              ? selectedContact.recipientCellphone
                              : selectedContact.senderCellphone}
                          </ClientNumber>
                        )}
                    </ClientInfo>
                  </Box>
                  <Box sx={{ display: "flex", gap: 1 }}>
                    <IconButton onClick={handleSearchClick}>
                      <SearchIcon />
                    </IconButton>
                    <ButtonAdd onClick={handleSearchSelect}>
                      Actualizar
                    </ButtonAdd>
                  </Box>
                </>
              )}
            </ChatHeader>

            <ChatMessages>
              {!datos?.messages?.length ? (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100%",
                  }}
                >
                  <Typography>No hay mensajes en esta conversación</Typography>
                </Box>
              ) : (
                datos?.messages?.map((items) =>
                  items.type === TIPOS_DOCUMENTOS.text ? (
                    <Box
                      key={items.uuid}
                      ref={(el) => {
                        if (el) messageRefs.current[items.uuid] = el;
                      }}
                      sx={{
                        backgroundColor:
                          searchMode &&
                          searchTerm &&
                          items.message
                            .toLowerCase()
                            .includes(searchTerm.toLowerCase())
                            ? "rgba(255, 249, 196, 0.6)"
                            : "transparent",
                        borderRadius: 1,
                      }}
                    >
                      <Texto
                        key={items?.uuid}
                        texto={items?.message}
                        tipos={
                          items?.senderCellphone === CELL_PHONE_COBRANZA
                            ? TIPOS_MENSAJES.enviado
                            : TIPOS_MENSAJES.recibido
                        }
                        times={items.timeSent}
                      />
                    </Box>
                  ) : items.type === TIPOS_DOCUMENTOS.image ? (
                    <Box
                      key={items.uuid}
                      ref={(el) => {
                        if (el) messageRefs.current[items.uuid] = el;
                      }}
                    >
                      <Image
                        key={items?.uuid}
                        imageKey={items.message}
                        tipos={
                          items?.senderCellphone === CELL_PHONE_COBRANZA
                            ? TIPOS_MENSAJES.enviado
                            : TIPOS_MENSAJES.recibido
                        }
                        times={items.timeSent}
                        onClick={() => {
                          setModalMediaSrc(items.message);
                          setModalMediaType("image");
                          setOpenImageModal(true);
                        }}
                        fetchMediaUrl={fetchMediaUrl}
                      />
                    </Box>
                  ) : items.type === TIPOS_DOCUMENTOS.video ? (
                    <Box
                      key={items.uuid}
                      ref={(el) => {
                        if (el) messageRefs.current[items.uuid] = el;
                      }}
                    >
                      <Video
                        key={items.uuid}
                        videKey={items.message}
                        tipos={
                          items?.senderCellphone === CELL_PHONE_COBRANZA
                            ? TIPOS_MENSAJES.enviado
                            : TIPOS_MENSAJES.recibido
                        }
                        times={items.timeSent}
                        onClick={(url) => {
                          setModalMediaSrc(url);
                          setModalMediaType("video");
                          setOpenImageModal(true);
                        }}
                        fetchMediaUrl={fetchMediaUrl}
                      />
                    </Box>
                  ) : items.type === TIPOS_DOCUMENTOS.document ? (
                    <Box
                      key={items.uuid}
                      ref={(el) => {
                        if (el) messageRefs.current[items.uuid] = el;
                      }}
                    >
                      <Document
                        key={items.uuid}
                        document={items.message}
                        tipos={
                          items?.senderCellphone === CELL_PHONE_COBRANZA
                            ? TIPOS_MENSAJES.enviado
                            : TIPOS_MENSAJES.recibido
                        }
                        times={items.timeSent}
                        fetchMediaUrl={fetchMediaUrl}
                      />
                    </Box>
                  ) : items.type === TIPOS_DOCUMENTOS.interactive ? (
                    <Box
                      key={items.uuid}
                      ref={(el) => {
                        if (el) messageRefs.current[items.uuid] = el;
                      }}
                    >
                      <Interactive
                        key={items.uuid}
                        texto={items?.message}
                        content={items.buttons}
                        tipos={
                          items?.senderCellphone === CELL_PHONE_COBRANZA
                            ? TIPOS_MENSAJES.enviado
                            : TIPOS_MENSAJES.recibido
                        }
                        times={items.timeSent}
                      />
                    </Box>
                  ) : items.type === TIPOS_DOCUMENTOS.audio ? (
                    <Box
                      key={items.uuid}
                      ref={(el) => {
                        if (el) messageRefs.current[items.uuid] = el;
                      }}
                    >
                      <Audio
                        key={items.uuid}
                        audioKey={items.message}
                        tipos={
                          items?.senderCellphone === CELL_PHONE_COBRANZA
                            ? TIPOS_MENSAJES.enviado
                            : TIPOS_MENSAJES.recibido
                        }
                        times={items.timeSent}
                        fetchMediaUrl={fetchMediaUrl}
                      />
                    </Box>
                  ) : null
                )
              )}
              <div ref={messagesEndRef} />
            </ChatMessages>

            {showScrollToBottom && (
              <Button
                variant="contained"
                color="primary"
                startIcon={<ArrowDownwardIcon />}
                style={{
                  position: "absolute",
                  bottom: 90,
                  right: 50,
                  zIndex: 10,
                  borderRadius: 20,
                  background: "#00a884",
                  minWidth: 0,
                  padding: "8px 16px",
                  fontWeight: 600,
                }}
                onClick={() => {
                  scrollToBottom();
                  setShowScrollToBottom(false);
                }}
              >
                Bajar a mensajes nuevos
              </Button>
            )}

            <ChatInput>
              <MessageInput
                placeholder="Escribe un mensaje aquí"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                onKeyPress={(e) => {
                  if (e.key === "Enter") {
                    handleSendMessage();
                  }
                }}
              />
              <IconButton onClick={handleSendMessage} color="primary">
                <SendIcon />
              </IconButton>
            </ChatInput>
          </ChatContainer>
        ) : (
          <WelcomeScreen>
            <img
              src="https://user-images.githubusercontent.com/15075759/28719144-86dc0f70-73b1-11e7-911d-60d70fcded21.png"
              alt="WhatsApp"
            />
            <Typography
              variant="h5"
              sx={{ color: "#41525d", marginBottom: "10px" }}
            >
              Chat de Cobranza
            </Typography>
            <Typography variant="body1" sx={{ color: "#667781" }}>
              Selecciona un chat para comenzar la conversación
            </Typography>
          </WelcomeScreen>
        )}
      </ChatSection>
      <Modal open={openImageModal} onClose={() => setOpenImageModal(false)}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100vh",
            bgcolor: "rgba(0,0,0,0.8)",
            position: "relative",
          }}
        >
          <IconButton
            onClick={() => setOpenImageModal(false)}
            sx={{
              position: "absolute",
              top: 20,
              right: 20,
              color: "#fff",
              background: "rgba(0,0,0,0.3)",
              zIndex: 2,
              "&:hover": { background: "rgba(0,0,0,0.6)" },
            }}
          >
            <CloseIcon sx={{ fontSize: 32 }} />
          </IconButton>
          {modalMediaType === "image" ? (
            <img
              src={modalMediaSrc}
              alt="Vista ampliada"
              style={{
                maxHeight: "90vh",
                maxWidth: "90vw",
                borderRadius: "8px",
                boxShadow: "0 4px 20px rgba(0,0,0,0.5)",
              }}
            />
          ) : (
            <video
              src={modalMediaSrc}
              controls
              autoPlay
              style={{
                maxHeight: "90vh",
                maxWidth: "90vw",
                borderRadius: "8px",
                boxShadow: "0 4px 20px rgba(0,0,0,0.5)",
                background: "#000",
              }}
            />
          )}
        </Box>
      </Modal>
    </MainContainer>
  );
}
